import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, Typography, CircularProgress } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import _ from 'lodash';
import { APIRouteConstants } from 'constants/routeConstants';
import instance from 'configs/axiosConfig';

import { useAuth } from 'oidc-react';
function Payments() {
  const location = useLocation();
  const {
    orderId,
    selectedPaymentMode,
    selected,
    selectedAddress,
    auth,
    paymentUrl
  } = location.state || {};
  
  const [loading,setLoading]=useState(true)

console.log(loading, "location state")
  const getPeachPaymentLink = async () => {
    if (!orderId || !selectedPaymentMode) {
      enqueueSnackbar("Missing required payment data.", { variant: 'error' });
      return;
    }
    setLoading(true)
    const formData = {
      transactionId: orderId,
      selectedPaymentMode: selectedPaymentMode?.id,
      order_notes: '',
      // d6_access_token: auth?.userData?.access_token || null,
      delivery_option: selected,
      paymentUrl,
    };

    if (selectedAddress?.id) {
      formData["addressId"] = selectedAddress.id;
    }

    try {
      const res = await instance.post(
        APIRouteConstants.DASHBOARD.PROCEED_PAYMENT,
        formData
      );
      const { data, response } = res;

      if (response && response.status === 400) {
        const errorMsg = response?.data?.error;
        if (
          errorMsg === "Failed to create Sticitt payment ID." ||
          errorMsg === "Failed to initiate Peach Payments checkout."
        ) {
          enqueueSnackbar("Payable amount cannot be zero.", { variant: 'error' });
        }
        return;
      }

      if (!_.isEmpty(data) && data.checkout_url) {
        setLoading(false)
        window.location.replace(data.checkout_url); // Navigate to Peach checkout
      }
    } catch (error) {
      console.error("Payment initiation failed:", error);
      enqueueSnackbar("Something went wrong.", { variant: "error" });
    }
  };
  
  useEffect(() => {
    
    if (paymentUrl) {
      setTimeout(() => {
        setLoading(false)
        window.location.replace(paymentUrl); // Navigate to Peach checkout
      }, 2000);
    }
    // getPeachPaymentLink();
  }, [location]);

  return (
    <Grid container justifyContent="center" alignItems="center" minHeight="100vh">
    {loading && <Grid item textAlign="center">
       <CircularProgress />
       <Typography mt={2}>Please wait, we're fetching your payment link...</Typography>
     </Grid>}
   </Grid>
  );
}

export default Payments;

// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { Grid, Typography, CircularProgress } from '@mui/material';
// import { enqueueSnackbar } from 'notistack';
// import _ from 'lodash';
// import { APIRouteConstants } from 'constants/routeConstants';
// import instance from 'configs/axiosConfig';

// function Payments() {
//   const location = useLocation();
//   const {
//     orderId,
//     selectedPaymentMode,
//     selected,
//     selectedAddress,
//     auth,
//   } = location.state || {};

//   const [loading, setLoading] = useState(true);

//   const getPeachPaymentLink = async () => {
//     if (!orderId || !selectedPaymentMode) {
//       enqueueSnackbar("Missing required payment data.", { variant: 'error' });
//       setLoading(false);
//       return;
//     }

//     const formData = {
//       transactionId: orderId,
//       selectedPaymentMode: selectedPaymentMode?.id,
//       order_notes: '',
//       delivery_option: selected,
//     };

//     if (selectedAddress?.id) {
//       formData["addressId"] = selectedAddress.id;
//     }

//     try {
//       const res = await instance.post(
//         APIRouteConstants.DASHBOARD.PROCEED_PAYMENT,
//         formData
//       );

//       const { data, response } = res;

//       if (response && response.status === 400) {
//         const errorMsg = response?.data?.error;
//         if (
//           errorMsg === "Failed to create Sticitt payment ID." ||
//           errorMsg === "Failed to initiate Peach Payments checkout."
//         ) {
//           enqueueSnackbar("Payable amount cannot be zero.", { variant: 'error' });
//         }
//         setLoading(false);
//         return;
//       }

//       if (!_.isEmpty(data) && data.checkout_url) {
//         // Only show loader if staying on same domain — delay for smoother UX
//         setTimeout(() => {
//           window.location.href = data.checkout_url;
//         }, 500);
//       } else {
//         setLoading(false);
//       }
//     } catch (error) {
//       console.error("Payment initiation failed:", error);
//       enqueueSnackbar("Something went wrong.", { variant: "error" });
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     // getPeachPaymentLink();

//     // Set up an interval to check if URL has changed
//     const originalURL = window.location.href;

//     const interval = setInterval(() => {
//       if (window.location.href !== originalURL) {
//         setLoading(false); // URL changed — stop showing loader
//         clearInterval(interval);
//       }
//     }, 500);

//     return () => clearInterval(interval);
//   }, []);

//   return loading ? (
//     <Grid container justifyContent="center" alignItems="center" minHeight="100vh">
//       <Grid item textAlign="center">
//         <CircularProgress />
//         <Typography mt={2}>We're redirecting you to the payment page...</Typography>

//       </Grid>
//     </Grid>
//   ) : null;
// }

// export default Payments;
